import React from "react";
import { withRouter } from "react-router-dom";
import Wrapper from "../../../components/Template/Wrapper";
import { ContainerWrapper, ContainerBody } from "../../../components/GridComponent/AdminLte.js";
import OrgChartCharts from "./OrgChartCharts";
import OrgChartEditor from "./OrgChartEditor";
import "../../../components/Dashboard/OrgChart/OrgChart.css";
import "./OrgChartManage.css";

/**
 * HR: Organizational Charts. /app/hr/OrgCharts/ = list; /app/hr/OrgCharts/{id} = editor.
 * Same page frame as the other admin pages (Wrapper -> ContainerWrapper -> ContainerBody);
 * the route is HR-only (RouteList) and every API call is HR-gated on the server as well.
 */
const OrgChartManage = (props) => {
  // ProtectedRoute hands the route params over as `params` (not `match`)
  const params = props.params || (props.match && props.match.params) || {};
  const id = params.id ? Number(params.id) : null;
  return (
    <Wrapper {...props}>
      <ContainerWrapper>
        <ContainerBody>
          {id ? <OrgChartEditor chartId={id} /> : <OrgChartCharts history={props.history} />}
        </ContainerBody>
      </ContainerWrapper>
    </Wrapper>
  );
};

export default withRouter(OrgChartManage);
